module.exports = __webpack_public_path__ + "static/media/Youtube Music.8a20f838.png";